import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogComponent } from './catalog/catalog.component';
import { SharedModule } from '../../shared/shared.module';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { DetailsModalComponent } from './details-modal/details-modal.component';
import { StatusModalComponent } from './status-modal/status-modal.component';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { AddTransactionComponent } from './add-transaction/add-transaction.component';
import { AddCommentComponent } from './add-comment/add-comment.component';
import { ImportComponent } from './import/import.component';
import { DiscountPointsComponent } from './discount-points/discount-points.component';
import { CreateBookingStayComponent } from './create-booking-stay/create-booking-stay.component';
import { ErrorSuccessMsgComponent } from './error-success-msg/error-success-msg.component'
import { HardDeleteMemberComponent } from './hard-delete-member/hard-delete-member.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    CatalogComponent,
    ConfirmModalComponent,
    DetailsModalComponent,
    StatusModalComponent,
    MessageModalComponent,
    AddTransactionComponent,
    AddCommentComponent,
    ImportComponent,
    DiscountPointsComponent,
    CreateBookingStayComponent,
    ErrorSuccessMsgComponent,
    HardDeleteMemberComponent
  ],
  entryComponents: [
    CatalogComponent,
    ConfirmModalComponent,
    MessageModalComponent,
    DetailsModalComponent,
    StatusModalComponent,
    AddTransactionComponent,
    AddCommentComponent,
    ImportComponent,
    DiscountPointsComponent,
    CreateBookingStayComponent,
    ErrorSuccessMsgComponent,
    HardDeleteMemberComponent
  ],
})
export class ModalsModule { }



// WEBPACK FOOTER //
// ./src/app/components/modals/modals.module.ts